import { globalErrorAtom } from '@/utils/global-states'
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/react'
import { useAtom } from 'jotai'

export interface ErrorData {
	message: string
	title?: string
	variant?: 'primary' | 'success' | 'danger'
}

export default function GlobalErrorModal() {
	const [errorState, setErrorState] = useAtom(globalErrorAtom)

	function onOpenChange(isOpen: boolean) {
		setErrorState({ ...errorState, isOpen })
	}

	return (
		<>
			<Modal
				backdrop="opaque"
				isOpen={errorState.isOpen}
				onOpenChange={onOpenChange}
				isDismissable={false}
				radius="md"
				motionProps={{
					variants: {
						enter: {
							y: 0,
							scale: 1,
							transition: {
								duration: 0.3,
								ease: 'easeOut',
							},
						},
						exit: {
							y: 0,
							scale: 0,
							transition: {
								duration: 0.2,
								ease: 'easeIn',
							},
						},
					},
				}}
				classNames={{
					//     body: "py-6",
					//     backdrop: "bg-[#292f46]/50 backdrop-opacity-40",
					//     base: "border-[#292f46] bg-[#19172c] dark:bg-[#19172c] text-[#a8b0d3]",
					//     header: "border-b-[1px] border-[#292f46]",
					//     footer: "border-t-[1px] border-[#292f46]",
					closeButton: 'hidden',
				}}
			>
				<ModalContent>
					{onClose => (
						<>
							<ModalHeader className="flex flex-col gap-1 uppercase">
								{errorState.data?.title || 'An error occurred'}
							</ModalHeader>
							<ModalBody>
								<div>
									<div id="modal-desc" className={'mb-6'}>
										{errorState.data?.message || 'A technical error occurred, please try again later.'}
									</div>
								</div>
							</ModalBody>
							<ModalFooter className={'justify-start'}>
								<Button
									className={'bg-colourSky60 text-white border-0 cursor-pointer mr-5 w-[100px] hover:bg-colourSky80'}
									radius={'md'}
									onPress={onClose}
								>
									Close
								</Button>
							</ModalFooter>
						</>
					)}
				</ModalContent>
			</Modal>
		</>
	)
}
